$(document).ready(function () {
    $('#Hamburger').on({
        mouseenter: function (evt) {
            $('#Hamburger').addClass('Active');
        },
        mouseleave: function (evt) {
            $('#Hamburger').removeClass('Active');
        },
        click: function (evt) {
            evt.preventDefault();

            $('#Hamburger').removeClass('Active');
            $('#Slider').toggleClass('HamburgerMenuOpen');
            $('#Header #Main #LinksMobile').toggleClass('HamburgerMenuOpen');

            return false;
        }
    });

    $('#MenuLogo').on('click', function (evt) {
        evt.preventDefault();

        $('#Hamburger').removeClass('Active');
        $('#Slider').removeClass('HamburgerMenuOpen');
        $('#Header #Main #LinksMobile').removeClass('HamburgerMenuOpen');

        return false;
    });
});